<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                </nav>
            </b-col>
        </b-row>
        </base-header>
        <div>
            <!-- <vue-element-loading :active="loading" :is-full-screen="true" color="#fb6340"/> -->
            <loading :active="loadingCounter > 0" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6 container-padding">
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card no-body>
                            <b-tabs pills card>
                                <b-tab :title="language_terms['BASIC_INFORMATION']" active>
                                    <b-card-text>
                                        <card>
                                            <div slot="header">
                                                <h3 >{{language_terms['BASIC_INFORMATION']}} 
                                                    <span v-if="asset.code">({{asset.code}})</span>
                                                </h3>
                                            </div>
                                            <b-row>
                                                <b-col md="4" v-if="is_edit">
                                                    <label class="form-control-label">{{language_terms['ASSET_CLASSIFICATION']}}</label>
                                                    <multiselect
                                                        open-direction="bottom"
                                                        :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                                        :placeholder="language_terms['SEARCH_ADD_TAG']"
                                                        label="code"
                                                        track-by="code"
                                                        :options="asset_classifications"
                                                        text-field="name"
                                                        :multiple="false"
                                                        v-model="asset.assetclassification"
                                                        :taggable="false"
                                                        :disabled="!is_edit"
                                                        ></multiselect>
                                                </b-col>
                                                <b-col md="4" v-else>
                                                    <base-input :label="language_terms['ASSET_CLASSIFICATION']" v-model="asset.assetclassification_name" disabled></base-input>
                                                </b-col>

                                                <b-col md="8">
                                                    <base-input :label="language_terms['NAME']" v-model="asset.name" :disabled="!is_edit"></base-input>
                                                </b-col>
<!--
                                                <b-col md="4" v-if="is_edit">
                                                    <label class="form-control-label">{{language_terms['RFID']}}</label>
                                                    <multiselect
                                                        open-direction="bottom"
                                                        :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                                        :placeholder="language_terms['SEARCH_ADD_TAG']"
                                                        label="code"
                                                        track-by="code"
                                                        :options="rfids"
                                                        text-field="name"
                                                        :multiple="false"
                                                        v-model="asset.rfid"
                                                        :taggable="false"
                                                        :disabled="!is_edit"
                                                        ></multiselect>
                                                </b-col>
                                                <b-col md="4" v-else>
                                                    <base-input :label="language_terms['RFID']" v-model="asset.rfid_code" disabled></base-input>
                                                </b-col>

                                                <b-col md="4">
                                                    <base-input :label="language_terms['REFERENCE']" v-model="asset.reference" :disabled="!is_edit"></base-input>
                                                </b-col>
-->

                                                <b-col cols="12">
                                                    <base-input :label="language_terms['REMARKS']">
                                                        <textarea
                                                        class="form-control"
                                                        id="exampleFormControlTextarea1"
                                                        rows="3"
                                                        v-model="asset.remarks"
                                                        :disabled="!is_edit">
                                                        </textarea>
                                                    </base-input>
                                                </b-col>
                                            </b-row>
                                        </card>

                                        <card>
                                            <div slot="header">
                                                <h3 >Depreciation
                                                    <!-- <span v-if="asset_classification.code">({{asset_classification.code}})</span> -->
                                                </h3>
                                            </div>
                                            <b-row>
                                                <b-col md="3">
                                                    <base-input label="Acquisition Date" v-if="is_edit">
                                                        <flat-picker
                                                        slot-scope="{ focus, blur }"
                                                        @on-open="focus"
                                                        @on-close="blur"
                                                        style="background-color: white"
                                                        class="form-control datepicker"
                                                        v-model="asset.acquisition_date">
                                                        </flat-picker>
                                                    </base-input>
                                                    <base-input
                                                        :label="language_terms['DATE']"
                                                        v-model="asset.acquisition_date"
                                                        v-if="!is_edit"
                                                        type="date"
                                                        disabled/>
                                                </b-col>

                                                <b-col md="3">
                                                    <base-input label="Acquisition Value" v-model="asset.acquisition_value" type="number" min="0" :disabled="!is_edit"></base-input>
                                                </b-col>

                                                <b-col md="3">
                                                    <base-input label="Depreciation Duration (Months)" v-model="asset.decay_months" type="number" min="1" :disabled="!is_edit"></base-input>
                                                </b-col>

                                                <b-col md="3">
                                                    <base-input label="Residual Value" v-model="asset.residual_value" type="number" min="0" :disabled="!is_edit"></base-input>
                                                </b-col>

                                                <b-col md="3">
                                                    <label class="form-control-label">Fixed Asset Account</label>
                                                        <multiselect
                                                            v-model="asset.fixed_asset_account"
                                                            @input="onSelectAccount"
                                                            :disabled="!is_edit"
                                                            :options="account_list"
                                                            track-by="code"
                                                            :multiple="false" :close-on-select="true" :clear-on-select="false" open-direction="bottom" label="name" text-field="display_name"
                                                        />
                                                </b-col>

                                                <b-col md="3">
                                                    <label class="form-control-label">Provision for Depreciation Account</label>
                                                        <multiselect
                                                            v-model="asset.provision_for_depreciation_account"
                                                            @input="onSelectAccount"
                                                            :disabled="!is_edit"
                                                            :options="account_list"
                                                            track-by="code"
                                                            :multiple="false" :close-on-select="true" :clear-on-select="false" open-direction="bottom" label="name" text-field="display_name"
                                                        />                                                    
                                                </b-col>

                                                <b-col md="3">
                                                    <label class="form-control-label">Depreciation Account</label>
                                                        <multiselect
                                                            v-model="asset.depreciation_account"
                                                            @input="onSelectAccount"
                                                            :disabled="!is_edit"
                                                            :options="account_list"
                                                            track-by="code"
                                                            :multiple="false" :close-on-select="true" :clear-on-select="false" open-direction="bottom" label="name" text-field="display_name"
                                                        />    
                                                </b-col>

                                                <b-col md="3">
                                                    <label class="form-control-label">Disposal Account</label>
                                                        <multiselect
                                                            v-model="asset.disposal_account"
                                                            @input="onSelectAccount"
                                                            :disabled="!is_edit"
                                                            :options="account_list"
                                                            track-by="code"
                                                            :multiple="false" :close-on-select="true" :clear-on-select="false" open-direction="bottom" label="name" text-field="display_name"
                                                        />    
                                                </b-col>
                                                
                                            </b-row>
                                        </card>

                                    </b-card-text>
                                    <div class="floating-bar">
                                        <div class="floating-bar-container" align="center">
                                            <b-button-group>
                                                <b-button class="transparent-btn" v-if="!is_edit" @click ="clickOnEdit()">
                                                    <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                                                </b-button>
                                                <b-button class="transparent-btn" v-if="is_edit" @click="save()">
                                                    <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                                </b-button>
                                                <b-button class="transparent-btn" v-if="is_edit">
                                                    <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                                                </b-button>
                                                <b-button class="transparent-btn" v-if="$route.params.id != '_new'">
                                                    <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </div>
                                </b-tab>
                                <b-tab :title="language_terms['LINKED_ASSETS']" v-if="$route.params.id != '_new'">
                                    <b-row>
                                        <b-col cols="10">
                                            <label class="form-control-label">{{language_terms['ASSET']}}</label>
                                            <assetLookup v-bind:url="assetLookup" v-on:selected="selectAsset($event)" :lookupId="selected_asset_code" :v2="asset.id" :disabled="!is_edit"/>
                                        </b-col>
                                        <b-col cols="2" class="mt-4">
                                            <base-button icon type="primary" class="mt-1" @click="addAsset()" :disabled="!is_edit">
                                                <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                                            </base-button>
                                        </b-col>
                                        <b-col cols="12" class="mt-4">
                                           <b-table-simple striped hover responsive>
                                               <b-thead>
                                                    <th>{{language_terms['SNO']}}</th>
                                                    <th>{{language_terms['ASSET_CODE']}}</th>
                                                    <th>{{language_terms['NAME']}}</th>
                                                    <th></th>
                                               </b-thead>
                                                <b-tbody>
                                                    <b-tr v-for="(row, index) in asset.asset_childrens" :key="index">
                                                        <td>{{index+1}}</td>
                                                        <td>{{row.child_asset_code}}</td>
                                                        <td>{{row.child_asset_name}}</td>
                                                        <td>
                                                            <base-button icon type="warning" size="sm" @click="deleteAsset(row, index)" :disabled="!is_edit">
                                                                <i class="fa fa-trash"></i>
                                                            </base-button>
                                                        </td>
                                                    </b-tr>
                                                </b-tbody>
                                           </b-table-simple>
                                        </b-col>
                                    </b-row>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

import assetLookup from "@/components/Autocomplete.vue";

export default 
{
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            rfids:state => state.assets.rfids,
            asset_classifications:state => state.assets.asset_classifications,
            asset_filter: state => state.assets.asset_filter,
            asset_data: state=> state.assets.asset_data,
            accounts_for_fy: (state) => state.accounts.accounts_for_fy,
            is_created:state =>state.assets.is_created,
            is_updated:state =>state.assets.is_updated,
            is_child_added:state => state.assets.is_child_added,
            is_child_deleted:state =>state.assets.is_child_deleted
        })
    },
    components:{
        Loading,
        assetLookup,
        flatPicker,
    },
    data(){
        return{
            loadingCounter:0,
            account_list:[],
            is_edit:false,
            selected_asset_code:"",
            selected_asset_id:"",
            selected_asset_name:"",
            assetLookup:apiRoutes['LIST_ASSET_CHILDREN_TO_ADD'],
            asset:{
                rfid:{},
                asset_childrens:[]
            }
        }
    },
    methods:
    {
        async getAllAccountsForFY()
        {
            // this.loadingCounter++
            // let filter = {fy:this.voucher.fy}
            this.asset.date = '2023-01-01'
            let filter = {date:this.asset.date}
            await this.$store.dispatch("accounts/getAccountForFys", filter)
            this.account_list = this.accounts_for_fy
            console.log(this.account_list)
            // this.loadingCounter--
        },
        async addAsset()
        {
            if(this.selected_asset_id != '' && this.selected_asset_id != null)
            {
                await this.$store.dispatch("assets/addAssetChildern", {parent_asset_id:this.asset.id, child_asset_id:this.selected_asset_id})
                if(this.is_child_added)
                {
                    await this.retrieveAsset(this.asset.code)
                    this.asset = this.asset_data

                    this.selected_asset_id = null
                    this.selected_asset_code = null
                    this.selected_asset_name = null
                    
                }
            }
        },
        async deleteAsset(row, index)
        {
            await this.$store.dispatch("assets/deleteChild", {id:row.id})
            if(this.is_child_deleted)
            {
                await this.retrieveAsset(this.asset.code)
                this.asset = this.asset_data
            }
        },
        selectAsset(obj)
        {   
            if(obj)
            {
                this.selected_asset_code = obj.code
                this.selected_asset_name = obj.name 
                this.selected_asset_id = obj.id
            }
        },
        async searchAssets()
        {
            this.loadingCounter++
            let filter = {keyword:"",active_only:"1"}
            if(this.asset_filter)
            {
                filter = this.asset_filter
            }
            await this.$store.dispatch('assets/quickSearch', filter)
            this.loadingCounter--
        },
        async save()
        {
            if(this.$route.params.id == '_new')
            {
                await this.$store.dispatch("assets/create", this.asset);
                if(this.is_created)
                {
                    await this.searchAssets()
                    this.$router.push("/assets-management/assets")
                }
            }
            else
            {
                await this.$store.dispatch("assets/update", this.asset);
                if(this.is_updated)
                {
                    await this.searchAssets()
                    this.$router.push("/assets-management/assets")
                }
            }
        },
        clickOnEdit()
        {
            this.is_edit = true
        },
        async retrieveAsset(asset_code)
        {
            this.loadingCounter++
            await this.$store.dispatch("assets/fetch", {code:asset_code});
            this.loadingCounter--
        },
        async onSelectAccount(selectedOption)
        {
            this.asset.fixed_asset_account_tag = null
        },

    },
    async mounted()
    {
        this.loadingCounter++
        this.getAllAccountsForFY()
        
        if(this.$route.params.id == '_new')
        {
            this.is_edit = true
        }
        else
        {
            await this.retrieveAsset(this.$route.params.id)
            this.asset = this.asset_data

        }

        await this.$store.dispatch("assets/listRfids", {asset_id:this.$route.params.id});
        await this.$store.dispatch("assets/listAssetClassifications", {})
        await this.$store.dispatch("assets/listAccountCodes", {})
        
        //await this.$store.dispatch("assets/listAssetClassifications", {})
        
        this.loadingCounter--
    }

}
</script>
